// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: true,
  baseApiUrl: "https://legacyuat-api.reveleer.com/corewebservice/api/",
  bannerConfigUrl: "https://hdvi-public.s3.us-east-1.amazonaws.com/uat/banner/banner.json",
  documentServiceApiUrl: "https://legacyuat-api.reveleer.com/documentservice/api/",
  ssoRedirectUrl: "https://uat.reveleer.com/login/sso-redirect",
  auth0RedirectUrl: "https://uat.reveleer.com/login/select-user",
  idlePeriodInSec: 1740,
  idlePeriodInSecForEmployee: 540,
  timeoutPeriodInSec: 60,
  auth0Domain: "uat-reveleer.us.auth0.com",
  auth0ClientID: "OHIUiXC23HpPC1TAgCNFGeP2Lylot3LJ",
  userPilotToken: "",
  helpjuiceUrl: "https://help.reveleer.com"
};

